// DS1.7.9
import React from 'react';
import classnames from 'classnames';
import s from './DeviationFlag.scss';
const DeviationFlag = ({ variant, size, className })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[variant], s[size], className)
    });
DeviationFlag.displayName = 'DeviationFlag';
export default DeviationFlag;

//# sourceMappingURL=DeviationFlag.js.map